import { useCallback, useLayoutEffect, useRef } from 'react';

export function useEvent<T extends (...args: Parameters<T>) => ReturnType<T>>(
  callback: T | undefined
) {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback(
    ((...args) => {
      return callbackRef.current?.(...args);
    }) as T,
    []
  );
}
